module.exports = __webpack_public_path__ + "static/media/sc_12_i.154a5a2b.png";